import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import defaultLogo from '../../../../assets/images/CompanyDefaultLogo.svg';
import defaultProfileBg from '../../../../assets/images/default_profile_bg.svg';
import { ReactComponent as Icon } from '../../../../assets/images/referralButton.svg';
import { ReactComponent as ShareIcon } from '../../../../assets/images/Share.svg';
import Button from '../../../../components/shared/Button/Button';
import { normalizeURL } from '../../../../helpers/commonHelper';
import ShareModal from '../../ShareModal/ShareModal';

import style from './ProfileHeader.module.scss';

const ProfileHeader = ({ company, handleSocialShare, onCopyLink, identifier, isPublic }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    cover_picture_image: coverPictureImage,
    logo_image: logoImage,
    name: companyName,
    industry: companyIndustry,
    organization_size: organizationSize,
    web_link: webLink,
  } = company;

  const companyModal = {
    name: companyName,
    industry: companyIndustry?.name,
    employeeRange: organizationSize?.name,
    logo: logoImage?.image_url,
    type: 'companyProfile',
  };

  const openingsTargetUrl = isPublic ? `/company/${identifier}/jobs` : `/jobs?company=${identifier}`;

  const handleOpeningTargetUrl = () => {
    navigate(openingsTargetUrl);
  };
  const openWebLink = (link) => {
    const url = normalizeURL(link);
    window.open(url, '_blank');
  };

  return (
    <div className={`${style.container} d-flex flex-column`}>
      <div className={style.bgImageDiv}>
        <img src={coverPictureImage?.image_url || defaultProfileBg} className={style.bgImage} alt="profile-bg" />
      </div>
      <div className="row no-gutters">
        <div className={`col-3 col-sm-3 ${style.profileImageDiv}`}>
          <img src={logoImage?.image_url || defaultLogo} alt="profile-bg" className={style.profileImage} />
        </div>

        <div className="col-9 col-sm-9 d-flex align-items-center">
          <div className={style.profileSection}>
            <div className={`flex-column ${style.userInfo}`}>
              <h3>{companyName}</h3>
              <h6>
                <span className={style.industryNameWeb}>{companyIndustry?.name}</span>
                <div className={style.industryNameMob}> {companyIndustry?.name}</div>
                <span className={style.lineBreak}> | </span>
                <br className={style.orgSizeAllign} />
                {organizationSize?.name}
              </h6>
            </div>
          </div>
        </div>
      </div>

      <div className={style.btnDiv}>
        <Button
          variant="secondary-new"
          onClick={() => {
            handleOpeningTargetUrl();
          }}
        >
          View Openings
        </Button>
        <div className={style.sourceContDiv}>
          {webLink && (
            <div className={style.webLink}>
              <Icon onClick={() => openWebLink(webLink)} />
            </div>
          )}
          <div className={style.sourceCont}>
            <div>
              <ShareIcon onClick={() => setIsModalOpen(true)} className={style.shareIcon} />
              <div>
                <ShareModal
                  isOpen={isModalOpen}
                  onClose={() => setIsModalOpen(false)}
                  company={companyModal}
                  handleSocialShare={handleSocialShare}
                  onCopyLink={onCopyLink}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
